<companies-card-list
  [navigateUrl]="navigateUrlPath"
  [companyIdDependency]="companyIdDependency"
  [companyNameDependency]="companyNameDependency"
  [configDependencies]="configDependencies"
  [filterOptions]="filterOptions"
></companies-card-list>
